import React from 'react'
import Props from './types'
import styles from './MediaDrawer.module.scss'
import classnames from 'classnames'
import Icon, { IconType } from '@bt-react/components/Icon'

const MediaDrawer: React.FC<Props> = props => {

  const {
    hidden = false
  } = props

  const mediaDrawerClasses = classnames(styles[`MediaDrawer`], {
    [styles[`MediaDrawer--hide`]]: hidden
  })

  return <div
    className={mediaDrawerClasses}
    data-closed={hidden}
    data-bdd={`talks-media-drawer${props.dataBdd ? `-${props.dataBdd}` : ``}`}
    tabIndex={-1}
  >
    <div className={styles['MediaDrawer-Handle']}>
      <button
        className={styles['MediaDrawer-Rounded']}
        type='button'
        onClick={props.onClick}
        data-bdd='talks-media-drawer-close-button'
      >
        <div className={styles[`Button`]}>
          <div className={styles[`Button-Layer`]}>
            <div className={styles[`Button-Grow`]} />
          </div>
          <div className={styles[`Button-Layer`]}>
            <Icon
              name={IconType.iconName.angleDown}
              dataBdd='talks-media-drawer-close-button-icon'
            />
          </div>
        </div>
      </button>
    </div>
    <div className={styles[`MediaDrawer-Content-Container`]}>
      <div className={styles[`MediaDrawer-Content`]}>
        <div className={styles[`MediaDrawer-Head`]}>
          <div
            className={classnames(styles[`MediaDrawer-Title`], styles[`heading-text-400`])}
            data-bdd='talks-media-drawer-title'
          >
            {props.title}
          </div>
          <div
            className={styles[`MediaDrawer-Action`]}
            data-bdd='talks-media-drawer-action'
          >
            {props.action}
          </div>
        </div>
        {props.children}
      </div>
    </div>
  </div>

}

export default MediaDrawer
